module.exports = __webpack_public_path__ + "img/0030.606f7c17.png";